import { render, staticRenderFns } from "./atc.vue?vue&type=template&id=1541227e&scoped=true&"
import script from "./atc.vue?vue&type=script&lang=js&"
export * from "./atc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1541227e",
  null
  
)

export default component.exports